/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CategorySyncCategoryResponse } from './CategorySyncCategoryResponse';

export type CategorySyncCategoryResponseApiRespoonse = {
    data?: CategorySyncCategoryResponse;
    status?: CategorySyncCategoryResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace CategorySyncCategoryResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

